const copyToClipboard = (url) => {
  const el = document.createElement('textarea');
  el.value = url;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export default copyToClipboard;



// WEBPACK FOOTER //
// ./src/utils/copyToClipboard.js